import { css } from '@emotion/css';
import { rotateAnimation } from 'constants/global.style';
import { colors } from 'constants/theme';
// import header from 'assets/images/bg/bgheader.png';

const headerStyles = {
    wrap: css`
        background: #002287;
        background-size: 100% 100%;
    `,
    container: css`
        max-width: 1260px;
        margin: 0 auto;
    `,
    content: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 2px 0;
    `,
    logo: css`
        width: 180px;
        cursor: pointer;
        border-radius: 10px;
        padding: 7px 7px 3px;
        img {
            width: 100%;
        }
    `,

    userHeader: css`
        display: flex;
        align-items: center;
    `,
    btnLeft: css`
        background: #1A3893;
        display: flex;
        align-items: center;
        border-radius: 40px;
        padding: 6px 12px;
        margin-right: 10px;
        cursor: pointer;
    `,
    wrapBtnAccount: css`
        position: relative;
    `,
    btnAccount: css`
        gap: 10px;
        transition: 0.1s;
        position: relative;
        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 100%;
            width: 100%;
            height: 0;
            background: ${colors.white};
            transition: 0.1s;
            transition-delay: 0.1s;
        }
        &.show {
            border-radius: 18px 18px 0 0;
            background: ${colors.white};
            &::before {
                display: block;
                height: 3px;
            }
            p {
                color: initial;
            }
            .arrow-icon {
                transform: rotate(180deg);
            }
        }
    `,
    username: css`
        font-size: 14px;
        color: #f4f4f5;
    `,
    avatar: css`
        width: 24px;
    `,
    arrow: css`
        width: 12px;
        transition: 0.25s;
    `,
    btnBalance: css`
        align-self: stretch;
        img {
            width: 18px;
            margin-right: 8px;
        }
        p {
            font-size: 14px;
            color: ${colors.yellow};
        }
    `,
    rotatingBalance: css`
        img {
            animation: ${rotateAnimation} 0.8s linear infinite;
        }
    `,

    btnAction: css`
        display: flex;
        gap: 10px;
        position: relative;
            /* 11 */
        .deposit {
            cursor: pointer;
            outline: none;
            font-weight: bold;
            text-align: center;
            border-radius: 5px;
            box-shadow: 1px 1px 2px rgba(0, 0, 0, .4);
            position: relative;
            overflow: hidden;
            border: 0;
            &:first-child {
                background: linear-gradient(to bottom ,#E02B35, #9A1A34);
            }
            &.btn-active {
                &:before {
                    position: absolute;
                    content: '';
                    display: inline-block;
                    top: -180px;
                    left: 0;
                    width: 30px;
                    height: 100%;
                    background-color: #fff;
                    animation: shiny-btn1 3s ease-in-out infinite;
                }
            }
            &.btn-wl {
                background: linear-gradient(to bottom ,#4A92FF, #8400FF);
            }
            &.btn-funs {
                background: linear-gradient(to bottom ,#009F73, #005A42);
            }
            &:hover {
                box-shadow: 1px 2px 5px rgba(0, 0, 0, .4) !important;
                transform: scale(1.05);
            }
        }

        @keyframes shiny-btn1 {
            0% { -webkit-transform: scale(0) rotate(45deg); opacity: 0; }
            80% { -webkit-transform: scale(0) rotate(45deg); opacity: 0.5; }
            81% { -webkit-transform: scale(4) rotate(45deg); opacity: 1; }
            100% { -webkit-transform: scale(50) rotate(45deg); opacity: 0; }
        }
    `,
    noti: css`
        padding: 0 4px;
        margin-right: 10px;
        cursor: pointer;
        position: relative;
        img {
            width: 20px;
        }
    `,
    countUnreadMsg: css`
        position: absolute;
        left: calc(50% + 3px);
        top: calc(50% - 16px);

        background: ${colors.red};
        width: 16px;
        height: 16px;
        border-radius: 20px;

        display: flex;
        align-items: center;
        justify-content: center;

        font-size: 10px;
        color: ${colors.white};
        line-height: 0;
    `,
    logout: css`
    cursor: pointer;
    display: flex;
    align-items: center;
    color: #FFB677;
        &:hover {
            transition: 0.2s all ease-in;
            opacity: 0.8;
            transform: scale(1.05);
        }
        img {
            width: 25px;
            margin-top: 3px;
            margin-right: 5px;
        }
    `
};
export default headerStyles;
